import { useEffect, useRef, useState } from "react";
import { saveActionNotes } from "../../lib/api";

// Coaches Brief + Action Taken. Persisted (debounced) so refresh/navigation never loses text.
export function ActionNotes({ card, readOnly, onValues }) {
  const [brief, setBrief] = useState(card.coaches_brief || "");
  const [taken, setTaken] = useState(card.action_taken || "");
  const [saved, setSaved] = useState("");
  const dirty = useRef(false);
  const lastEdit = useRef(0);
  const timer = useRef(null);

  useEffect(() => {
    if (!dirty.current && Date.now() - lastEdit.current > 6000) { setBrief(card.coaches_brief || ""); setTaken(card.action_taken || ""); }
  }, [card.coaches_brief, card.action_taken]);

  useEffect(() => { onValues?.({ brief, taken }); }, [brief, taken, onValues]);
  useEffect(() => () => clearTimeout(timer.current), []);

  const queue = (b, t) => {
    dirty.current = true;
    lastEdit.current = Date.now();
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try { await saveActionNotes(card.id, b, t); setSaved("Saved"); } catch { setSaved("Not saved. Retrying on next edit"); }
      dirty.current = false;
    }, 700);
  };

  const field = (label, value, set, key) => (
    <label className="block">
      <span className="label-eyebrow">{label}</span>
      {readOnly ? (
        <p className="mt-1 text-brand-ink whitespace-pre-wrap" data-testid={`${key}-text-${card.id}`}>{value || "None"}</p>
      ) : (
        <textarea
          className="input-warm w-full mt-1 min-h-[80px]"
          value={value}
          onChange={(e) => { set(e.target.value); queue(key === "coaches-brief" ? e.target.value : brief, key === "action-taken" ? e.target.value : taken); }}
          data-testid={`${key}-input-${card.id}`}
        />
      )}
    </label>
  );

  return (
    <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid={`action-notes-${card.id}`}>
      {field("Coaches Brief", brief, setBrief, "coaches-brief")}
      {field("Action Taken", taken, setTaken, "action-taken")}
      {!readOnly && saved && <p className="text-xs text-brand-ink-muted md:col-span-2" data-testid={`notes-saved-${card.id}`}>{saved}</p>}
    </div>
  );
}

export default ActionNotes;
